import {
  Column,
  Job,
  LabourStore,
} from "@shared-ui-components/DataTable/types";
import { getPropertyName } from "@utils/dataTableHelper";

import {
  formatNumberWithCommaAndDollar,
  formatWithPercentage,
} from "@src/constants";
import { getPropertyCustomExtraPath } from "@src/constants/Dashboard";

// Functions
export const refineData = (data: LabourStore[] | Job[]) => {
  if (data[0] !== null && data[0] !== undefined) {
    const keys = Object.keys(data["0"]);

    if (keys.includes("job")) {
      const refined = data?.map((el: any) => {
        const refinedObject = {
          name: el.job,
          amtAct: el.amt_act,
          amtPct: el.amt_pct,
          planAct: el.plan_act,
          planPct: el.plan_pct,
          total: el.total,
        };
        return refinedObject;
      });
      return refined;
    }
  }
  const refined = data?.map((el: any) => {
    const refinedObject = {
      name: getPropertyName(el.property_short_name, el.name),
      amtAct: el.amt_act,
      amtPct: el.amt_pct,
      planAct: el.plan_act,
      planPct: el.plan_pct,
      total: el.total,
    };
    return refinedObject;
  });
  return refined;
};

export const getLabourBreakdownCustomExtraPath = (
  filters: LabourBreakdownFilterType
) => {
  let path = "";
  const { filterBy, foreCastData, planData } = filters || {};

  const customPath = getPropertyCustomExtraPath(filters);

  path = customPath;

  if (foreCastData) {
    path += `&target=forecast`;
  }

  if (planData) {
    path += `&target=plan`;
  }

  if (filterBy) {
    path += `&filter_by=${filterBy?.toString()}`;
  }

  let url = path;
  if (path.length && path[0] !== "?") {
    url = url.replace("&", "?");
  }
  return url;
};

// Constants

export const columns: Column[] = [
  { id: "name", label: "Store", minWidth: 110 },
  {
    id: "amtAct",
    label: "AMT $",
    minWidth: 86,
    align: "left",
    format: formatNumberWithCommaAndDollar,
  },
  {
    id: "amtPct",
    label: "AMT %",
    minWidth: 86,
    align: "left",
    format: formatWithPercentage,
  },
  {
    id: "planAct",
    label: "Plan $",
    minWidth: 86,
    align: "left",
    format: formatNumberWithCommaAndDollar,
  },
  {
    id: "planPct",
    label: "Plan %",
    minWidth: 86,
    align: "left",
    format: formatWithPercentage,
  },
];
export const filterOptions = [
  { label: "By Job Code", value: "job_code" },
  { label: "By Store", value: "store" },
];
